<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header" v-if="!modal" >Información del Artículo</div>
          <b-form>
            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols= 'labelCols'
              horizontal>
              <b-form-input 
                id="nombre"
                v-model.trim= "$v.nombre.$model" 
                :state="nombreValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Tipo de Artículo"
              label-for="articuloTipo"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarArticuloTipo">
                  <b-input-group-text>
                    <i class="fa fa-search"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="agregarArticuloTipo">
                  <b-input-group-text>
                    <i class="fa fa-plus"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="editarArticuloTipo"
                    v-if="articuloTipo">
                  <b-input-group-text>
                    <i class="fa fa-edit"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="articuloTipo"
                  :value="articuloTipoNombre"
                  :state="articuloTipoValido"
                  readonly
                  type="text"/>
                <b-form-invalid-feedback id="articuloTipoFeedback">
                  {{ articuloTipoInvalidoMsj }}
                </b-form-invalid-feedback>          
              </b-input-group>
            </b-form-group>

            <!-- <app-articulo-tipo
              label="Tipo"
              :nombre="articuloTipoNombre"
              :labelCols="labelCols"
              :valido="articuloTipoValido"
              :lista="articulosTiposList"
              :msjInvalido="articuloTipoInvalidoMsj"
              @validate="validate"
              @updated="articuloTipoActualizado">
            </app-articulo-tipo>   -->

            <b-form-group
              label="Descripción"
              label-for="descripcion"
              :label-cols="labelCols"
              horizontal>
              <b-form-textarea
                id="descripcion"
                v-model="$v.descripcion.$model" 
                rows="5"
                max-rows="50"
                :state="descripcionValida"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="descripcionFeedback">
                {{ descripcionInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="inactivo"
                  v-model="inactivo"
                  value= true
                  unchecked-value= false>
                  Inactivo
              </b-form-checkbox>
            </b-form-group>
          </b-form>

          <div slot="footer" v-if="modal">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="goBack">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="searchArticuloTipoModal"
        title="Seleccionar Tipo de Artículo"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="search-modal">
      <app-search-articulo-tipo
        @articuloTipoSeleccionado="articuloTipoSeleccionado">
      </app-search-articulo-tipo>  
    </b-modal>

    <b-modal ref="articuloTipoModal"
        title="Datos del Tipo Artículo"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-articulo-tipo
        :modal="true"
        :articuloTipoId="articuloTipoSeleccionadoId"
        @updateArticuloTipo="updateArticuloTipo"
        @closeArticuloTipo="closeArticuloTipo">
      </app-articulo-tipo>  
    </b-modal>

    <app-a-b-m-button
      v-if= "!modal"
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
// import ArticuloTipo from '../shared/abmSelect.vue';
import SearchArticuloTipo from '../articulosTipos/SearchList.vue';
import ArticuloTipo from '../articulosTipos/ABM.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { required, numeric, maxLength, minValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'articulo/getField',
  mutationType: 'articulo/updateField',
});

export default {
  name: 'ArticuloABM',
  components: {
    // appArticuloTipo: ArticuloTipo,
    appSearchArticuloTipo: SearchArticuloTipo,
    appArticuloTipo: ArticuloTipo,
    appABMButton: ABMButtons,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    articuloId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      noValidar: true,
      nombreValido: null,
      nombreInvalidoMsj: '',
      descripcionValida: null,
      descripcionInvalidaMsj: '',
      articuloTipoValido: null,
      articuloTipoInvalidoMsj: '',

      // articulosTipos: [],
      // articulosTiposList: [],
      articuloTipoSeleccionadoId: 0,

      tableBusy: false,
      labelCols: 2,
      inicializando: false
    }
  },
  computed: {
    ...mapFields([
      'id',
      'nombre',
      'descripcion',
      'articuloTipoId',
      'articuloTipo',
      'articuloTipoNombre',
      'inactivo',
    ])
  },  
  created() {
    let articuloId = 0;

    if (!this.modal) {
      if (this.$route.params){
        if (this.$route.params.id){
          articuloId = this.$route.params.id;
        }
      }
    }

    if (this.modal) {
      if (this.articuloId) {
        if (this.articuloId != 0) {
          articuloId = this.articuloId;
        }
      }
    }

    this.showSpinner();
    this.inicializando = true;
    this.$store.dispatch('articulo/inicializar', articuloId)
      // .then(() => this.getDatosAdicionales())
      .catch(error => this.showErrorMsj(error))
      .finally(() => {
        this.hideSpinner();
        this.inicializando = false;
      })
  },  
  methods: {
    // getDatosAdicionales() {
    //   this.getArticulosTipos();
    // },
    // getArticulosTipos() {
    //   this.$store.dispatch('articulosTipos/getList')
    //   .then(() => {
    //     this.articulosTipos = this.$store.getters['articulosTipos/list'];
    //     this.articulosTiposList = this.$store.getters['articulosTipos/selectList'];
    //   })
    //   .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de tipos de artículos.'));
    // },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'nombre' || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (!this.$v.nombre.required) {
            this.nombreInvalidoMsj= 'Debe ingresar el nombre del artículo.';
          } else if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre solo puede contener hasta 50 caracteres';
          } 
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }
        
      if (campo == 'descripcion' || validarTodos) {
        if (this.$v.descripcion.$error) {
          this.descripcionValida = false;
          // if (!this.$v.descripcion.required) {
          //   this.descripcionInvalidaMsj = 'Debe ingresar la descripción del artículo.';
          // } else 
          if (!this.$v.descripcion.maxLength) {
            this.descripcionInvalidaMsj = 'La descripción solo puede contener hasta 2500 caracteres';
          }
        } else {
          this.descripcionValida = null;
          this.descripcionInvalidaMsj = '';
        }
      }
    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      // let articuloTipo = null;
      // if (this.articuloTipoNombre) {
      //   articuloTipo = this.getSelected(this.articulosTipos, this.articuloTipoNombre);
      // }
      // this.$store.dispatch('articulo/setArticuloTipo', articuloTipo);

      let articuloTipoError = true;
      if (this.articuloTipo) {
        if (this.articuloTipo.id) {
          if (this.articuloTipo.id != 0) {
            articuloTipoError = false;
          }
        }
      }
      if (articuloTipoError) {
        save = Boolean(false);
        this.articuloTipoValido = false;
        this.articuloTipoInvalidoMsj = "Debe seleccionar el tipo de artículo correspondiente.";
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('articulo/save')
            .then(()  => {
              if (!this.modal) {
                this.showModalMsj('Los cambios se registraron con éxito.', this.goList, this.goList, 'light');
              } else {
                this.$emit('updateArticulo', 
                  this.$store.getters['articulo/articulo']);
              }
            })
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner())
        }
      } 
    },
    goBack() {
      if (!this.modal) {
        this.$router.go(-1);
      } else {
        this.$emit('closeArticulo');
      }
    },
    goList() {
      this.$router.push({ name: "Articulos" });
    },
    seleccionarArticuloTipo() {
      this.$refs.searchArticuloTipoModal.show();
    },
    articuloTipoSeleccionado(item) {
      this.$refs.searchArticuloTipoModal.hide();
      this.$store.dispatch('articulo/setArticuloTipo', item)
        .catch(error => this.showAlert(error, 'danger'));
    },
    agregarArticuloTipo() {
      this.articuloTipoSeleccionadoId = 0;
      this.$refs.articuloTipoModal.show();
    },
    editarArticuloTipo() {
      this.articuloTipoSeleccionadoId = this.articuloTipoId;
      this.$refs.articuloTipoModal.show();
    },
    updateArticuloTipo(articuloTipo) {
      this.$refs.articuloTipoModal.hide();
      this.$store.dispatch('articulo/setArticuloTipo', articuloTipo)
        .catch(error => this.showAlert(error, 'danger'));
    },
    closeArticuloTipo() {
      this.$refs.articuloTipoModal.hide();
    },
    // articuloTipoActualizado(articuloTipoNombre) {
    //   if (!this.inicializando) {
    //     this.articuloTipoNombre = articuloTipoNombre;

    //     this.articuloTipoValido = null;
    //     this.articuloTipoInvalidoMsj = '';
    //   }
    // },
  },
  watch: {
  },
  validations: {
    nombre: {
      required,
      maxLength: maxLength(50)
    },
    descripcion: {
      // required,
      maxLength: maxLength(2500)
    },
  },  
}
</script>

<style>
</style>
